<template>
  <el-row>
    <el-col
      @click.native="rouJump(item)"
      :span="colSpan"
      v-for="(item, index) in dataList"
      :key="item.value"
      style="display: inline-block;width: 50%;padding: 5px 0;text-align: center;"
    >
      <div class="quick-entry">
        <span class="content" :class="{ extentContent: item.extendIcon }">
          <i :class="item.icon"></i>
          <span>{{ item.label }}</span>
        </span>
        <el-tooltip
          effect="dark"
          :content="item.extendLabel"
          placement="top-start"
        >
          <i :class="item.extendIcon + ' extendIcon'"></i>
        </el-tooltip>
<!--        <el-divider-->
<!--          direction="vertical"-->
<!--          v-if="index != dataList.length - 1"-->
<!--        ></el-divider>-->
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "QuickEntrys",
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    colSpan() {
      return 24 / this.dataList.length;
    },
  },
  methods: {
    rouJump(val) {
      if (val.path) {
        this.$router.push({
          path: val.path,
        });
      } else {
        window.location.href(val.name);
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "../../styles/theme";
/deep/ .el-col{
  &:not(:last-child){
    border-right: 1px solid #2c3e50;
  }
}
.quick-entry {
  font-size: 19px;
  color: #303133;
  .content {
    cursor: pointer;
    i {
      margin-right: 10px;
    }
  }
  .content:hover {
    color: @theme-color;
  }
  .extendIcon {
    color: #2264a0;
    cursor: pointer;
  }
  .extentContent {
    margin-right: 20%;
  }
  .el-divider--vertical {
    background-color: #2c3e50;
    height: 2rem;
  }
}
</style>
